// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__font-normal-hjpxBc {
  color: rgba(28, 31, 35, .8);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ {
  display: flex;
  position: relative;
  align-items: center !important;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ:first-child > div:first-child > div > div:first-child, .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ:first-child > div:first-child > div > div:last-child {
  top: 12px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ:first-child > div:last-child {
  margin-top: 0;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ .semi-form-field {
  flex: 1;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ .semi-tree-option-expand-icon {
  align-items: center;
  height: 24px;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__level-icon-lFCMD1 {
  align-self: stretch;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__wrapper-gwydXw {
  flex: 1;
  align-items: center;
  margin-top: 10px;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9 {
  margin-top: 10px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__more-level-ENv0zi {
  cursor: default;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__more-level-ENv0zi > span, .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__more-level-ENv0zi > div {
  cursor: pointer;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__more-level-ENv0zi:hover, .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__more-level-ENv0zi:active {
  background: none;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9:first-child {
  margin-top: 0;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-container-nPTw70 {
  align-items: baseline;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-container-nPTw70 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__name-kUbNEQ {
  color: rgba(28, 31, 35, .8);
  word-break: keep-all;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-container-nPTw70 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__tag-T3ylSI {
  background: rgba(230, 232, 234, .76);
  border-radius: 3px;
  flex-shrink: 0;
  align-items: center;
  margin-left: 8px;
  padding: 2px 8px;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-container-nPTw70 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__tag-T3ylSI .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__label-ayL83t {
  color: rgba(28, 31, 35, .6);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"font-normal": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__font-normal-hjpxBc`,
	"fontNormal": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__font-normal-hjpxBc`,
	"container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__container-ezeCsQ`,
	"level-icon": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__level-icon-lFCMD1`,
	"levelIcon": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__level-icon-lFCMD1`,
	"wrapper": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__wrapper-gwydXw`,
	"readonly-icon-container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9`,
	"readonlyIconContainer": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-icon-container-fv6Zc9`,
	"more-level": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__more-level-ENv0zi`,
	"moreLevel": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__more-level-ENv0zi`,
	"readonly-container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-container-nPTw70`,
	"readonlyContainer": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__readonly-container-nPTw70`,
	"name": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__name-kUbNEQ`,
	"tag": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__tag-T3ylSI`,
	"label": `------packages-common-biz-components-src-parameters-components-custom-tree-node-index-module__label-ayL83t`
};
export default ___CSS_LOADER_EXPORT___;
